import { Box, Typography, ListItem } from '@mui/material';
import React from 'react';

import { Image, LineItem } from 'components';
import { COUNTRIES } from 'lib/constants/countries';
import { removeUnderscoresAndCapitalize } from 'lib/utils';
import { capitalize, compose, filter, join, size, toString } from 'lodash/fp';

const UserDetails = ({ user }) => (
	<>
		<Box xs={12} item container spacing={1}>
			<Box xs={12} lg={12} item>
				<Typography component="span" variant="h3">
					Avatar
				</Typography>
			</Box>
			<Box xs={12} lg={12} item>
				<ListItem>
					<Image src={user.avatar_url} variant="rounded" size={240} />
				</ListItem>
			</Box>

			<Box xs={12} lg={12} item>
				<Typography component="span" variant="h3">
					Basic Information
				</Typography>
			</Box>
			<Box xs={12} md={4} item>
				<LineItem label="Name" value={user.name} />
			</Box>
			<Box xs={12} md={4} item>
				<LineItem label="Email" value={user.email} />
			</Box>
			<Box xs={12} md={4} item>
				<LineItem label="Birthday" value={user.dob} />
			</Box>
			<Box xs={12} md={4} item>
				<LineItem
					label="Phone Number"
					value={(user.dail_code || '') + ' ' + user.phone_number}
				/>
			</Box>
			<Box xs={12} md={4} item>
				<LineItem
					label="Role"
					value={removeUnderscoresAndCapitalize(user.role)}
				/>
			</Box>
			<Box xs={12} md={4} item>
				<LineItem
					label="Paid"
					value={compose(capitalize, toString)(user.paid)}
				/>
			</Box>

			<Box xs={12} md={4} item>
				<LineItem label="Promo Code" value={user.promo_code} />
			</Box>
			<Box xs={12} md={8} item></Box>
			<Box xs={12} lg={12} item>
				<Typography component="span" variant="h3">
					Player Card
				</Typography>
			</Box>
			{[
				'control',
				'defending',
				'dribbling',
				'passing',
				'physical',
				'shooting'
			].map((skill) => (
				<Box xs={12} md={4} item key={`${skill}`}>
					<LineItem
						label={capitalize(skill)}
						value={user && user.player_card && user?.player_card[skill]}
					/>
				</Box>
			))}

			<Box xs={12} md={8} item></Box>

			<Box xs={12} lg={12} item>
				<Typography component="span" variant="h3">
					Location
				</Typography>
			</Box>
			<Box xs={12} md={4} item>
				<LineItem label="City" value={user.city} />
			</Box>
			<Box xs={12} md={4} item>
				<LineItem
					label="Country"
					value={
						user.country
							? COUNTRIES.find((c) => c.value == user.country)?.label
							: '-'
					}
				/>
			</Box>
			<Box xs={12} md={4} item>
				<LineItem label="Nationality" value={user.passport_country} />
			</Box>
			<Box xs={12} lg={12} item>
				<Typography component="span" variant="h3">
					Player Profile
				</Typography>
			</Box>

			<Box xs={12} md={4} item>
				<LineItem label="Summary" value={user.summary} />
			</Box>
			<Box xs={12} md={4} item>
				<LineItem label="Player Level" value={user.player_level} />
			</Box>
			<Box xs={12} md={4} item>
				<LineItem
					label="Interested Opportunties"
					value={user.interested_opportunities}
				/>
			</Box>
			<Box xs={12} md={4} item>
				<LineItem
					label="Positions"
					value={compose(join(', '))(user.positions)}
				/>
			</Box>
			<Box xs={12} md={4} item>
				<LineItem label="Preferred Foot" value={user.preferred_foot} />
			</Box>
			<Box xs={12} md={4} item>
				<LineItem label="Current Club" value={user.current_club} />
			</Box>
			<Box xs={12} md={4} item>
				<LineItem
					label="Agent"
					value={compose(capitalize, toString)(user.agent)}
				/>
			</Box>
			<Box xs={12} md={4} item>
				<LineItem label="Height (CM)" value={user.height} />
			</Box>
			<Box xs={12} md={4} item>
				<LineItem label="Weight (KG)" value={user.weight} />
			</Box>

			<Box xs={12} md={4} item>
				<LineItem label="Education" value={user.education} />
			</Box>
			<Box xs={12} md={8} item></Box>

			<Box xs={12} lg={12} item>
				<Typography component="span" variant="h3">
					Favourites
				</Typography>
			</Box>
			<Box xs={12} md={4} item>
				<LineItem label="Shirt Number" value={user.shirt} />
			</Box>
			<Box xs={12} md={4} item>
				<LineItem label="Favorite Boot" value={user.favorite_boot} />
			</Box>
			<Box xs={12} md={4} item>
				<LineItem label="Favorite Club" value={user.favorite_club} />
			</Box>
			<Box xs={12} md={4} item>
				<LineItem label="Favorite Brand" value={user.favorite_brand} />
			</Box>
			<Box xs={12} md={4} item>
				<LineItem label="Favorite Player" value={user.favorite_player} />
			</Box>

			<Box xs={12} lg={12} item>
				<Typography component="span" variant="h3">
					App Usage
				</Typography>
			</Box>

			<Box xs={12} md={4} item>
				<LineItem
					label="Player Card Total"
					value={user.player_card?.overall.value}
				/>
			</Box>
			<Box xs={12} md={4} item>
				<LineItem label="Referral Points" value={user.community_points} />
			</Box>
			<Box xs={12} md={4} item>
				<LineItem label="XP" value={user.experience_points} />
			</Box>
			<Box xs={12} md={4} item>
				<LineItem
					label="Completed Lessons (count)"
					value={user.completed_lesson_ids?.length}
				/>
			</Box>
			<Box xs={12} md={4} item>
				<LineItem
					label="Completed Courses (count)"
					value={user.completed_course_ids?.length}
				/>
			</Box>

			<Box xs={12} md={4} item></Box>

			<Box xs={12} md={4} item>
				<LineItem
					label="Highlight uploads (count)"
					value={compose(
						toString,
						size,
						filter((v) => v.videoable_type === null)
					)(user.videos)}
				/>
			</Box>

			<Box xs={12} md={4} item>
				<LineItem
					label="Lesson uploads (count)"
					value={compose(
						toString,
						size,
						filter((v) => v.videoable_type === 'Lesson')
					)(user.videos)}
				/>
			</Box>

			<Box xs={12} md={4} item>
				<LineItem
					label="Feedback Attempt uploads (count)"
					value={compose(
						toString,
						size,
						filter((v) => v.videoable_type === 'FeedbackAttempt')
					)(user.videos)}
				/>
			</Box>

			<Box xs={12} lg={12} item>
				<Typography component="span" variant="h3">
					Contact Information
				</Typography>
			</Box>
			<Box xs={12} lg={12} item>
				<Typography component="span" variant="subtitle2">
					Parent / Guardian
				</Typography>
			</Box>
			<Box xs={12} md={4} item>
				<LineItem label="Name" value={user.first_guardian?.name} />
			</Box>
			<Box xs={12} md={4} item>
				<LineItem label="Email" value={user.first_guardian?.email} />
			</Box>
			<Box xs={12} md={4} item>
				<LineItem
					label="Phone Number"
					value={user.first_guardian?.phone_number}
				/>
			</Box>
			<Box xs={12} lg={12} item>
				<Typography component="span" variant="subtitle2">
					Second Parent / Guardian
				</Typography>
			</Box>
			<Box xs={12} md={4} item>
				<LineItem label="Name" value={user.second_guardian?.name} />
			</Box>
			<Box xs={12} md={4} item>
				<LineItem label="Email" value={user.second_guardian?.email} />
			</Box>
			<Box xs={12} md={4} item>
				<LineItem
					label="Phone Number"
					value={user.second_guardian?.phone_number}
				/>
			</Box>
			<Box xs={12} lg={12} item>
				<Typography component="span" variant="subtitle2">
					Coach
				</Typography>
			</Box>
			<Box xs={12} md={4} item>
				<LineItem label="Name" value={user.coach?.name} />
			</Box>
			<Box xs={12} md={4} item>
				<LineItem label="Email" value={user.coach?.email} />
			</Box>
			<Box xs={12} md={4} item>
				<LineItem label="Phone Number" value={user.coach?.phone_number} />
			</Box>
		</Box>
	</>
);

export default UserDetails;
